import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SocialLink } from 'site-modules/shared/components/social-media/social-link/social-link';

const SOCIAL_LINKS_ORDER = ['FACEBOOK', 'INSTAGRAM', 'TWITTER', 'X', 'YOUTUBE', 'GOOGLE_PLUS', 'TIKTOK'];

export class DealerSocialLinks extends Component {
  orderSocialLinks = socialLinks => {
    const newSocialLinks = {};
    const orderedSocialLinks = [];

    socialLinks.forEach(socialLink => {
      newSocialLinks[socialLink.title.toUpperCase()] = socialLink;
    });

    SOCIAL_LINKS_ORDER.forEach(socialLinkName => {
      const socialLink = newSocialLinks[socialLinkName];

      if (!socialLink) return;

      orderedSocialLinks.push(socialLink);
    });

    return orderedSocialLinks;
  };

  render() {
    const { socialLinks } = this.props;
    if (!(socialLinks && socialLinks.length)) return null;
    return (
      <div className="social-links my-2">
        <div className="medium d-inline-block text-gray-darker">Follow us:</div>
        {this.orderSocialLinks(socialLinks).map(socialLink => (
          <div key={socialLink.title} className="d-inline-block mx-0_75">
            <SocialLink
              ariaLabelExtra={'of dealership'}
              socialLink={socialLink}
              data-tracking-id="ddp_other_site_clickout"
            />
          </div>
        ))}
      </div>
    );
  }
}

DealerSocialLinks.propTypes = {
  socialLinks: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string,
      title: PropTypes.string,
    })
  ),
};

DealerSocialLinks.defaultProps = {
  socialLinks: [],
};
